export default {
  Prev: 'Prev',
  Next: 'Next',
  DATE_FORMAT: 'MM/DD/YYYY',
};
